<template>
  <div>
    <p class="cm-mg-p-wzd text-center">
      1.1 {{ $t('common_words.calendar_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-4">
        <fg-input
          :label="`${$t('common_words.name')}: *`"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('common_words.calendar_name')}...`"
          v-model="model.name"
          v-validate="modelValidations.name"
          type="text"
          name="common_words.name"
        ></fg-input>
      </div>
    </div>
    <p class="cm-mg-p-wzd">1.2 {{ $t('labor.payment_calendar_info_2') }}</p>
    <hr />
    <el-container style="border: 1px solid #eee">
      <el-aside width="20%" style="overflow-x: hidden">
        <div
          class="row"
          style="
            margin: 10px auto;
            width: 30%;
            font-size: 25px;
            cursor: pointer;
          "
        >
          <div class="col-6">
            <em
              v-tooltip.top-center="$t('common_words.year_add')"
              class="el-icon-circle-plus"
              @click="addYear"
            ></em>
          </div>
          <div class="col-6">
            <em
              v-tooltip.top-center="$t('common_words.year_delete')"
              class="el-icon-remove"
              @click="removeYear"
            ></em>
          </div>
        </div>
        <el-menu :default-openeds="['1']">
          <el-submenu index="1">
            <template slot="title"
              ><em class="el-icon-date"></em
              >{{ $t('common_words.years') }}</template
            >
            <el-menu-item-group class="custom-el-menu-item-group-cal">
              <el-menu-item
                @click="changeOptionYear(y)"
                v-for="(y, i) in model.years"
                :key="y"
                v-bind:class="i == 0 ? 'is-active' : ''"
                v-bind:index="y + '-' + y"
                style="min-width: 140px"
                class="custom-el-menu-item-cal"
              >
                {{ y }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <br />
          <div class="row">
            <select-component
              :dataOptions="periocityTypes"
              :initialSelection="flagPeriocity"
              :labelSelect="`${$t('labor.periodicity')}: *`"
              :rowClass="'col-4'"
              :requireClass="'required-periocity'"
              :isMultiple="false"
              @onChange="handleChangeSelected"
              @onClear="flagPeriocity = null"
              modelName="periocity"
            />
            <div class="col-4" v-if="flagPeriocity == 0">
              <fg-input
                v-model.number="model.periocity[model.yearSel]"
                v-validate="modelValidations.periocity"
                :label="`${$t('labor.day_count')}: *`"
                :error="getError('labor.day_count', true)"
                type="number"
                name="labor.day_count"
              >
              </fg-input>
            </div>
            <div class="col-4">
              <label class="label-primary" style="color: transparent">{{
                $t('common_words.filter')
              }}</label
              ><br />
              <l-button
                wide
                type="info"
                class="btn-filter"
                @click="handlePeriocity"
              >
                {{ $t('common_words.generate') }}
              </l-button>
            </div>
          </div>
          <br />
          <div
            class="row"
            v-if="
              renderComponent &&
              model.init_dates_week[model.yearSel] &&
              model.init_dates_week[model.yearSel].length > 0
            "
          >
            <div class="col-4 text-center custom-head-dark">
              {{ selectedPeriodicityDetails.name }}
            </div>
            <div class="col-4 text-center custom-head-dark">
              {{ $t('common_words.beginning') }}
              {{ selectedPeriodicityDetails.article }}
              {{ selectedPeriodicityDetails.name.toLowerCase() }}
            </div>
            <div class="col-4 text-center custom-head-dark">
              {{ $t('common_words.end') }}
              {{ selectedPeriodicityDetails.article }}
              {{ selectedPeriodicityDetails.name.toLowerCase() }}
            </div>
          </div>

          <div
            v-if="
              renderComponent &&
              model.init_dates_week[model.yearSel] &&
              model.init_dates_week[model.yearSel].length > 0
            "
          >
            <div
              class="row"
              v-for="(_, index) in model.init_dates_week[model.yearSel]"
              :key="index"
            >
              <div class="col-4 text-center">
                <p class="m-2" style="padding: 10px">{{ index + 1 }}</p>
              </div>
              <div class="col-4 d-flex justify-content-center">
                <el-date-picker
                  v-if="renderComponent"
                  :class="'text-center m-2'"
                  :placeholder="`${$t('common_words.select2')}...`"
                  @input="setEndDatePeriod(index)"
                  v-model="model.init_dates_week[model.yearSel][index]"
                  type="date"
                />
              </div>
              <div class="col-4 d-flex justify-content-center">
                <el-date-picker
                  v-if="renderComponent"
                  :class="'text-center m-2'"
                  :placeholder="`${$t('common_words.select2')}...`"
                  @input="setInitDatePeriod(index)"
                  v-model="model.end_dates_week[model.yearSel][index]"
                  type="date"
                />
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import mixinCalendar from 'src/util/mixinCalendar';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      model: {
        name: null,
        yearSel: moment().format('Y'),
        init_dates_week: { [moment().format('Y')]: [] },
        end_dates_week: { [moment().format('Y')]: [] },
        years: [Number.parseInt(moment().format('Y'))],
        periocity: { [moment().format('Y')]: null },
        step: 1,
      },
      flagPeriocity: null,
      modelValidations: {
        week: {
          required: true,
        },
        name: {
          required: true,
        },
        periocity: {
          required: true,
          min_value: 8,
          max_value: 29,
        },
      },
      periods: { [moment().format('Y')]: 0 },
    };
  },

  computed: {
    periocityTypes() {
      return [
        { id: 7, name: this.$i18n.t('common_words.weekly') },
        { id: 14, name: this.$i18n.t('common_words.biweekly_14') },
        { id: 15, name: this.$i18n.t('common_words.biweekly_15') },
        { id: 30, name: this.$i18n.t('common_words.monthly') },
        { id: 0, name: this.$i18n.t('common_words.other') },
      ];
    },

    selectedPeriodicityDetails() {
      const mapping = {
        7: {
          name: this.$i18n.t('common_words.week'),
          article: this.$i18n.t('common_words.of_the'),
        },
        14: {
          name: this.$i18n.t('common_words.fortnight_14'),
          article: this.$i18n.t('common_words.of_the'),
        },
        15: {
          name: this.$i18n.t('common_words.fortnight_15'),
          article: this.$i18n.t('common_words.of_the'),
        },
        30: {
          name: this.$i18n.t('common_words.month'),
          article: this.$i18n.t('common_words.from_the'),
        },
        0: {
          name: this.$i18n.t('common_words.period'),
          article: this.$i18n.t('common_words.from_the'),
        },
      };

      const year = this.model.yearSel || new Date().getFullYear();
      const cycle = Number(this.model.periocity[year]) || 30;

      return (
        mapping[cycle] || {
          name: this.$i18n.t('common_words.period'),
          article: this.$i18n.t('common_words.from_the'),
        }
      );
    },
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters, mixinCalendar],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    handleChangeSelected(data) {
      if (data.name == 'periocity') {
        this.$set(this.model.periocity, this.model.yearSel, data.selects);
        this.$set(this, 'flagPeriocity', data.selects);
      } else {
        this.$set(this.model, data.name, data.selects);
      }
    },

    handlePeriocity() {
      this.showHideLoading(true);

      const year = this.model.yearSel || new Date().getFullYear();
      const isLeapYear =
        (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
      const daysInYear = isLeapYear ? 366 : 365;
      const cycle = Number(this.model.periocity[year]) || 30;

      this.$set(this.model.periocity, year, cycle);
      this.$set(this.model.init_dates_week, year, []);
      this.$set(this.model.end_dates_week, year, []);

      if (cycle === 15) {
        // Quincenal
        for (let month = 0; month < 12; month++) {
          const firstInit = new Date(year, month, 1);
          const firstEnd = new Date(year, month, 15);

          this.model.init_dates_week[year].push(firstInit);
          this.model.end_dates_week[year].push(firstEnd);

          const secondInit = new Date(year, month, 16);
          const lastDay = new Date(year, month + 1, 0).getDate();
          const secondEnd = new Date(year, month, lastDay);

          this.model.init_dates_week[year].push(secondInit);
          this.model.end_dates_week[year].push(secondEnd);
        }

        this.$set(this.periods, year, 24); // 2 quincenas por mes
      } else if (cycle === 30) {
        // Mensual
        for (let month = 0; month < 12; month++) {
          const init = new Date(year, month, 1);
          const lastDay = new Date(year, month + 1, 0).getDate();
          const end = new Date(year, month, lastDay);

          this.model.init_dates_week[year].push(init);
          this.model.end_dates_week[year].push(end);
        }

        this.$set(this.periods, year, 12);
      } else {
        // 🔄 Periocidad personalizada (ej: 7, 10, 20 días, etc.)
        const numPeriods = Math.ceil(daysInYear / cycle);
        this.$set(this.periods, year, numPeriods);

        let currentInit = new Date(year, 0, 1);
        let currentEnd = new Date(currentInit);
        currentEnd.setDate(currentEnd.getDate() + cycle - 1);

        for (let i = 0; i < numPeriods; i++) {
          this.model.init_dates_week[year].push(new Date(currentInit));
          this.model.end_dates_week[year].push(new Date(currentEnd));

          // Avanzar al siguiente período
          currentInit = new Date(currentEnd);
          currentInit.setDate(currentInit.getDate() + 1);

          currentEnd = new Date(currentInit);
          currentEnd.setDate(currentEnd.getDate() + cycle - 1);
        }
      }

      this.forceRerender();
      this.showHideLoading(false);
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);

        return res;
      });
    },

    setEndDatePeriod(indexDate) {
      this.showHideLoading(true);

      const year = this.model.yearSel;
      const cycle = Number(this.model.periocity[year]) || 30;
      const init = this.model.init_dates_week[year][indexDate];
      if (!init) return;

      const end = new Date(init);
      end.setDate(end.getDate() + cycle - 1);
      this.$set(this.model.end_dates_week[year], indexDate, end);

      let prevInit = new Date(init);
      let prevEnd = new Date(end);

      const total =
        this.model.init_dates_week[year] &&
        this.model.init_dates_week[year].length
          ? this.model.init_dates_week[year].length - 1
          : 0;

      for (let i = indexDate + 1; i <= total; i++) {
        const nextInit = new Date(prevInit);
        nextInit.setDate(nextInit.getDate() + cycle);

        const nextEnd = new Date(prevEnd);
        nextEnd.setDate(nextEnd.getDate() + cycle);

        this.$set(this.model.init_dates_week[year], i, nextInit);
        this.$set(this.model.end_dates_week[year], i, nextEnd);

        prevInit = nextInit;
        prevEnd = nextEnd;
      }

      this.forceRerender();
      this.showHideLoading();
    },

    /** Cuando el usuario modifica la fecha FIN: recalcula la fecha INICIO */
    setInitDatePeriod(indexDate) {
      this.showHideLoading(true);

      const year = this.model.yearSel;
      const cycle = Number(this.model.periocity[year]) || 30;

      const end = this.model.end_dates_week[year][indexDate];
      if (!end) return;

      const init = new Date(end);
      init.setDate(init.getDate() - (cycle - 1));
      this.$set(this.model.init_dates_week[year], indexDate, init);

      this.forceRerender();
      this.showHideLoading();
    },

    /** Método que abre un modal para ingresar el año en especifico
     * validando que este año no esté presente antes de añadirlo
     */
    addYear() {
      SweetAlert.input(
        i18n.t('production.enter_year'),
        null,
        i18n.t('common_words.accept'),
        {
          type: 'number',
          placeholder: '',
        }
      )
        .then((result) => {
          if (!result.dismiss) {
            const year = result.value;
            if (year && !isNaN(year) && year > 1999 && year < 2101) {
              if (!this.model.years.includes(year)) {
                this.flagPeriocity = null;
                let newYear = Number.parseInt(year);
                this.model.years.unshift(newYear);
                this.activeItemYear();

                this.model.yearSel = this.model.years[0];
                this.model.init_dates_week[this.model.yearSel] = [];
                this.model.end_dates_week[this.model.yearSel] = [];
              } else {
                SweetAlert.warning(i18n.t('production.year_already_exists'));
              }
            } else {
              SweetAlert.warning(
                i18n.t('common_words.must_enter_valid_number')
              );
            }
          }
        })
        .catch((error) => {
          console.error('Error con el modal:', error);
        });
    },

    removeYear() {
      if (this.model.years.length > 1) {
        this.showHideLoading(true);

        let id = this.model.years.shift();
        delete this.model.init_dates_week[id];
        delete this.model.end_dates_week[id];

        this.model.yearSel = this.model.years[this.model.years.length - 1];
        this.activeItemYear();
        this.showHideLoading();
      }
    },

    activeItemYear() {
      Object.values(
        document.getElementsByClassName('custom-el-menu-item-cal')
      ).forEach((element) => {
        element.classList.remove('is-active');
      });

      setTimeout(() => {
        Object.values(
          document.getElementsByClassName('custom-el-menu-item-cal')
        )[0].classList.add('is-active');
      }, 20);

      this.forceRerender();
    },

    changeOptionYear(yearSel) {
      this.showHideLoading(true);
      this.model.yearSel = yearSel;

      const validValues = [7, 14, 15, 30, 0];
      const current = this.model.periocity[this.model.yearSel];

      if (!validValues.includes(Number(current))) {
        this.flagPeriocity = 0;
      } else {
        this.flagPeriocity = current;
      }

      try {
        let obj = event.target;
        setTimeout(() => {
          Object.values(
            document.getElementsByClassName('custom-el-menu-item-cal')
          ).forEach((element) => {
            if (obj != element) {
              element.classList.remove('is-active');
            }
          });
          this.showHideLoading();
        }, 20);
      } catch (error) {
        console.log(error);
        this.showHideLoading();
      }
    },
  },

  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));

      const { name, years, businesses, farms } = editForm;
      const init_dates_week = {};
      const end_dates_week = {};
      const periocity = {};
      const periods = {};
      const yearList = [];

      years.forEach((y) => {
        const year = Number.parseInt(y.year);

        yearList.push(year);
        periocity[year] = y.periocity;

        init_dates_week[year] = y.details.map(
          (d) => new Date(d.init_date_week + 'T00:00:00')
        );
        end_dates_week[year] = y.details.map(
          (d) => new Date(d.end_date_week + 'T00:00:00')
        );

        periods[year] = y.details.length;
      });

      this.model = {
        ...this.model,
        name,
        yearSel: yearList[0],
        years: yearList,
        periocity,
        init_dates_week,
        end_dates_week,
        business_ids: businesses.map((business) => business.id),
        farm_ids: farms.map((farm) => farm.id),
        businessSelected: businesses.map((business) => business.name),
        farmsSelected: farms.map((farm) => farm.name),
      };

      const validValues = [7, 14, 15, 30, 0];
      const current = this.model.periocity[this.model.yearSel];

      if (!validValues.includes(Number(current))) {
        this.flagPeriocity = 0;
      } else {
        this.flagPeriocity = current;
      }

      this.periods = periods;
    }
  },
};
</script>
